// react
// navigate
import { createSlice } from '@reduxjs/toolkit';
// formik
// @material-ui
// icons
// hooks
// @types
import { AxiosResponseModel } from '../../@types/base';
import { DashboardCountsModel, DashboardModel } from '../../@types/dashboard';
// redux
import { CONSTS } from './const';
import { dispatch } from '../store';
// routes
// components
// utils
import axios from '../../utils/axios';
// constants
import { HttpStatusCodes } from '../../constants/http-status-codes.enum';
import {
  GeneralAnalysisModel,
  GeneralAnalysisResultModel
} from '../../@types/generalAnalysis';

// ----------------------------------------------------------------------

type GeneralAnalysisState = {
  generalAnalysisError: boolean;
  isGeneralAnalysisLoading: boolean;
  // generalAnalysisList: GeneralAnalysisListModel[];
};

const initialState: GeneralAnalysisState = {
  generalAnalysisError: false,
  isGeneralAnalysisLoading: false
};

const slice = createSlice({
  name: 'generalAnalysis',
  initialState,
  reducers: {
    // ----------------------------------------------------------------------
    // GENERALANALYSIS
    // ----------------------------------------------------------------------

    // START GENERALANALYSIS LOADING
    startGeneralAnalysisLoading(state) {
      state.isGeneralAnalysisLoading = true;
    },

    // HAS ERROR GENERALANALYSIS
    hasErrorGeneralAnalysis(state, action) {
      state.isGeneralAnalysisLoading = false;
      state.generalAnalysisError = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const {} = slice.actions;

// ----------------------------------------------------------------------
// GENERALANALYSIS

export async function generalAnalysisWithReturn(
  generalAnalysis: GeneralAnalysisModel,
  fileUrls: string[],
  companyId: string,
  uuid: string
) {
  dispatch(slice.actions.startGeneralAnalysisLoading());
  try {
    generalAnalysis.imageUrls = fileUrls;
    generalAnalysis.companyId = companyId;
    generalAnalysis.uuid = uuid;
    const response: AxiosResponseModel<GeneralAnalysisResultModel> = await axios
      .post(CONSTS.GENERALANALYSIS_POST_GENERALANALYSIS, generalAnalysis)
      .catch((error) => {
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    if (response && response.status === HttpStatusCodes.StatusSuccess) {
      // await getAllGeneralAnalysissWithReturn();
      dispatch(slice.actions.hasErrorGeneralAnalysis(false));
    } else {
      dispatch(
        slice.actions.hasErrorGeneralAnalysis(response.data?.message || '')
      );
    }
    return response;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorGeneralAnalysis(error));
    return error.response.data;
  }
}

// ----------------------------------------------------------------------
